import {Mapper} from '@s-ui/domain'

export default class UrlMapper extends Mapper {
  /**
   * @constructor
   * @param {Object} param
   * @param {Function} param.toQueryString
   * @param {Object} param.config
   * @param {Object} param.valueObjectFactory
   */
  constructor({toQueryString, fromPageNameToConstantNamingPageName, config, valueObjectFactory}) {
    super()
    this._toQueryString = toQueryString
    this._fromPageNameToConstantNamingPageName = fromPageNameToConstantNamingPageName
    this._config = config
    this._valueObjectFactory = valueObjectFactory

    this._pageConfig = this._config.get('page')
    this._basePath = this._pageConfig.HOME_PATH_PATTERN
    this._adsListPageNames = this._config.get('page').ADS_LIST_PAGE_NAMES
    this._unselectedOfferType = this._config.get('search').UNSELECTED_OFFER_TYPE
    this._paths = this._config.get('COMMON').PATHS
    this._defaultOfferTypeId = this._config.get('search').DEFAULT_OFFER_TYPE_ID
    this._listingSectionIds = this._config.get('COMMON').LISTING_SECTION_IDS
    this._secondHandOfferType = this._config.get('search').OFFER_TYPE_SECOND_HAND
    this._adsListSubscriptionPathPattern = this._config.get('page').ADS_LIST_SUBSCRIPTION_PATH_PATTERN
    this._offerTypeSubscription = this._config.get('search').OFFER_TYPE_SUBSCRIPTION
  }

  setParams({pageName, params, path, query, search, listingSectionId}) {
    this._listingSectionId = listingSectionId
    this._pageName = this._fromPageNameToConstantNamingPageName.map(pageName)
    this._params = params || {}
    this._query = query || {}
    this._search = search || {}
    this._path = path || ''

    return this
  }

  _getTechnicalDetailsSearchPath() {
    return this._pageConfig.TECHNICAL_DETAILS_SEARCH_PATH_PATTERN
  }

  _getAdsListPath() {
    const pathPatterns = this._pageConfig.ADS_LIST_PATH_PATTERNS
    const [defaultAdsListCategory] = Object.keys(pathPatterns)

    const isSubscriptionOfferType =
      this._params.offerTypeId !== undefined && this._params.offerTypeId === this._offerTypeSubscription

    const defaultOfferTypeId =
      this._listingSectionId === this._listingSectionIds.ALL_VEHICLES
        ? this._unselectedOfferType
        : this._secondHandOfferType

    const {categoryId = defaultAdsListCategory, offerTypeId = isSubscriptionOfferType || defaultOfferTypeId} =
      this._params

    if (this._listingSectionId === this._listingSectionIds.ALL_VEHICLES) return this._paths.ADS_LIST_SEARCH

    const path =
      offerTypeId === this._offerTypeSubscription
        ? this._adsListSubscriptionPathPattern
        : pathPatterns?.[categoryId]?.[offerTypeId]

    return path || this._basePath
  }

  _getHomeAdsListSearchPath() {
    const {ADS_LIST_SEARCH} = this._config.get('COMMON').PATHS

    return `${ADS_LIST_SEARCH}`
  }

  _getStockPath() {
    const stockPattern = this._pageConfig.PROFESSIONAL_STOCK_PATH_PATTERN
    const {contractId, dealerSlug, section} = this._params

    const basePath = stockPattern.replace(':dealer', dealerSlug || contractId)

    const sectionPath = section ? `${section}/` : ''

    return basePath.replace(':section?/', sectionPath)
  }

  _getStockRentingPath() {
    const stockPattern = this._pageConfig.PROFESSIONAL_STOCK_RENTING_PATH_PATTERN
    const {dealerSlug, section} = this._params

    const basePath = stockPattern.replace(':dealer', dealerSlug)

    const sectionPath = section ? `${section}/` : ''

    return basePath.replace(':section?/', sectionPath)
  }

  _getAdsListPageName = ({pageName}) => {
    const isPageFromAdsListPage = this._adsListPageNames
      .map(this._fromPageNameToConstantNamingPageName.map)
      .includes(pageName)
    if (isPageFromAdsListPage) return pageName
  }

  _getAdsSubscriptionListPageName = ({pageName}) => {
    const isPageFromAdsListPage = this._adsListPageNames
      .map(this._fromPageNameToConstantNamingPageName.map)
      .includes(pageName)
    if (isPageFromAdsListPage) return pageName
  }

  _getPath() {
    const PAGE_PATTERN_NAME = `${this._pageName}_PATH_PATTERN`
    switch (this._pageName) {
      case 'TECHNICAL_DETAILS_SEARCH':
      case 'TECHNICAL_DETAILS_SEARCH_RESULTS':
        return this._getTechnicalDetailsSearchPath()
      case 'USER_SAVED_SEARCHES':
      case this._getAdsListPageName({pageName: this._pageName}):
        return this._getAdsListPath()
      case 'PROFESSIONAL_STOCK':
        return this._getStockPath()
      case 'PROFESSIONAL_STOCK_RENTING':
        return this._getStockRentingPath()
      case 'DEALERS_LIST':
        return this._path
      case 'HOME':
        return this._getHomeAdsListSearchPath()
      default:
        return this._pageConfig[PAGE_PATTERN_NAME] || this._basePath
    }
  }

  map = () => {
    const queryStrings = this._toQueryString(this._query, {
      arrayFormat: 'indice'
    })

    const hasQueryStrings = Boolean(queryStrings.length)
    const query = hasQueryStrings ? `?${queryStrings}` : ''

    const url = `${this._getPath()}${query}`

    return this._valueObjectFactory({url})
  }
}
